<template>
    <div class="contact-details-form">
        <InputWrap
            id="first_name"
            v-model="form.firstName"
            type="text"
            label="First Name"
            placeholder="First Name"
            autocomplete="given-name"
            :validation="validation.firstName"
        />
        <InputWrap
            id="last_name"
            v-model="form.lastName"
            type="text"
            label="Last Name"
            placeholder="Last Name"
            autocomplete="family-name"
            :validation="validation.lastName"
        />
        <InputWrap
            id="email"
            v-model="form.email"
            type="text"
            label="Email"
            placeholder="Email"
            autocomplete="email"
            :validation="validation.email"
        />
        <PhoneInputWrap
            id="phone"
            v-model="form.phone"
            type="text"
            label="Phone"
            placeholder="Phone"
            autocomplete="tel-national"
            :validation="validation.phone"
        />

        <transition name="fade">
            <div
                v-if="action === 'remote-appointment'"
                key="remote-appointment-fields"
                class="input-group"
            >
                <InputWrap
                    id="address"
                    v-model="form.address"
                    type="text"
                    label="Address"
                    placeholder="Address"
                    autocomplete="street-address"
                    :validation="validation.address"
                />
                <InputWrap
                    id="city"
                    v-model="form.city"
                    type="text"
                    label="City"
                    placeholder="City"
                    autocomplete="address-level2"
                    :validation="validation.city"
                />
                <InputWrap
                    id="state"
                    v-model="form.state"
                    type="text"
                    label="State"
                    placeholder="State"
                    autocomplete="address-level1"
                    :validation="validation.state"
                />
                <InputWrap
                    id="zip"
                    v-model="form.zip"
                    type="text"
                    label="Zip"
                    placeholder="Zip"
                    autocomplete="postal-code"
                    :validation="validation.zip"
                />
            </div>
            <div
                v-else-if="action === 'question'"
                key="question-fields"
                class="input-group"
            >
                <TextareaWrap
                    id="question"
                    v-model="form.question"
                    label="Question"
                    rows="6"
                    :validation="validation.question"
                />
            </div>
        </transition>
    </div>
</template>

<script>
import InputWrap from '@/components/form/input-wrap';
import PhoneInputWrap from '@/components/form/phone-input-wrap';
import TextareaWrap from '@/components/form/textarea-wrap';

export default {
    name: 'ContactDetailsForm',

    components: {
        InputWrap,
        PhoneInputWrap,
        TextareaWrap,
    },

    props: {
        form: {
            type: Object,
            required: true,
        },
        action: {
            type: String,
            required: true,
        },
        validation: {
            type: Object,
            required: false,
            default: undefined,
        },
    },

    created() {
        this.parseBasicFormFieldsFromUrl();
    },

    methods: {
        parseBasicFormFieldsFromUrl() {
            const params = this.$route.query;

            const fields = [
                'firstName',
                'lastName',
                'email',
                'phone',
                'templateId',
            ];

            for (const field of fields) {
                if (!!params[field]) {
                    this.form[field] = params[field];
                }
            }

            // update templateId to number if it exists
            if (!!this.form.templateId) {
                this.form.templateId = parseInt(this.form.templateId);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.contact-details-form {
    width: 100%;
    max-width: 28rem;
    padding: 2rem 1rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    // cascade into parts of form
    & .input-wrap-container {
        margin-top: 0.1rem;
    }
    // only remove top from very first item
    & > .input-wrap-container:first-child {
        margin-top: 0;
    }

    .input-group {
        width: 100%;
    }
}
</style>
